module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/006-6f3b5e09023f4cd5b63791c782f60364.jpg";